module.exports = __webpack_public_path__ + "static/media/how-it-works-lubricants-4.92131e7b.png";